var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, makeObservable } from 'mobx';
var ConversationRootStore = (function () {
    function ConversationRootStore(store) {
        Object.defineProperty(this, "messageStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        makeObservable(this);
        this.messageStore = store;
    }
    Object.defineProperty(ConversationRootStore.prototype, "getConversationBoxClass", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (isModal) {
            return isModal ? 'pxl-modal' : '';
        }
    });
    Object.defineProperty(ConversationRootStore.prototype, "getConversationContainerClass", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (isModal) {
            return isModal ? 'conversation-container pxl-modal__content' : 'conversation-container';
        }
    });
    __decorate([
        observable
    ], ConversationRootStore.prototype, "messageStore", void 0);
    return ConversationRootStore;
}());
export { ConversationRootStore };
